import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CouponsServices from "../../services/CouponServices";
import Pagetitle from "../../component/PageTitle";

function AddNewCouponCode() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    name: "",
    description: "",
    image: null, // Initialize as null instead of an empty string
    minimumPrice: "",
    numberOfCoupons: "",
    startDate: "",
    endDate: "",
    discountValue: "",
    discountType: "",
    status: ""
  });

  const [previewImage, setPreviewImage] = useState("img/placeholder-img.svg");

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues((prevState) => ({
        ...prevState,
        image: file,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
     // Validation for date range
     if (new Date(formValues.endDate) <= new Date(formValues.startDate)) {
      alert('End Date should be greater than Start Date.');
      return;
  }
    try {
      const formData = new FormData();
      for (const key in formValues) {
        // Check if the value is not null or undefined
        if (formValues[key] !== null && formValues[key] !== undefined) {
          formData.append(key, formValues[key]);
        }
      }

      const response = await CouponsServices.createCoupon(formData);

      alert("Coupon Added Successfully");
      navigate("/coupon-code");
    } catch (error) {
      console.error("Failed to add Coupon", error);
      alert( error.response.data.message ||'Failed to update Coupon');
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box">
        <div className="container-box-top-header justify-content-between">
          <h4>Cottage Information Section</h4>
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/coupon-code">
              Coupon Code List
            </Link>
          </div>
        </div>
        <div className="container-box-inner px-4">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Coupon Code*</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formValues.name}
                      onChange={handleInputChange}
                      placeholder="Enter Coupon Code Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Discount Type*</label>
                    <select className="form-select" name="discountType" onChange={handleInputChange} value={formValues.discountType} required>
                      <option selected="">Select Discount Type</option>
                      <option value="Percentage">Percentage (%)</option>
                      <option value="FixedRate">Fixed Rate</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Discount Value*</label>
                    <input
                      type="number"
                      name="discountValue"
                      className="form-control"
                      value={formValues.discountValue}
                      onChange={handleInputChange}
                      placeholder="Enter Discount Value"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Start Date*</label>
                    <input
                      type="date"
                      name="startDate"
                      className="form-control"
                      value={formValues.startDate}
                      onChange={handleInputChange}
                      placeholder="Enter Start Date"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>End Date*</label>
                    <input
                      type="date"
                      name="endDate"
                      className="form-control"
                      value={formValues.endDate}
                      onChange={handleInputChange}
                      placeholder="Enter End Date"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Usage Limit*</label>
                    <input
                      type="number"
                      name="numberOfCoupons"
                      className="form-control"
                      value={formValues.numberOfCoupons}
                      onChange={handleInputChange}
                      placeholder="Enter Usage Limit"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label htmlFor="imageUpload" className="form-label">Image</label>
                    <input
                      type="file"
                      name="image"
                      className="form-control"
                      id="imageUpload"
                      onChange={handleFileChange}
                      accept="image/*"
                    />
                    <div
                      className="file-preview d-flex"
                      style={{ marginBlock: "20px", alignItems: "center", justifyContent: "center" }}
                    >
                      <img
                        id="uploadFile"
                        src={previewImage}
                        alt="Preview"
                        style={{ maxWidth: "100%", height: "auto", border: "1px solid #ddd", borderRadius: "8px" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Minimum Order Value (Optional)</label>
                    <input
                      type="number"
                      name="minimumPrice"
                      className="form-control"
                      value={formValues.minimumPrice}
                      onChange={handleInputChange}
                      placeholder="Set Minimum Order Value"

                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="input-field">
                    <label>Status</label>
                    <select className="form-select" name="status" onChange={handleInputChange} value={formValues.status} required>
                      <option selected="">Select Status</option>
                      <option value="Active">Active </option>
                      <option value="Inactive">Expire</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="input-field">
                    <label>Description*</label>
                    <textarea
                      className="form-control video-desc"
                      name="description"
                      value={formValues.description}
                      onChange={handleInputChange}
                      placeholder='Description'
                      required
                    />
                  </div>
                </div>
              </div>
              <button className="site-btn-green" type="submit">
                Save Coupon
              </button>
            </form>
          </div>
        </div>
      </div>


    </div>
  );
}

export default AddNewCouponCode;
